export const SCENARIO_PERIOD_TEMPLATE_LINK =
    "https://docs.google.com/spreadsheets/d/1kVTm_WTno2dDckh4YVeGBZMYB3yFMvJZuQLL3hDJwD8/edit?gid=0#gid=0";
